import { AdviseCurrentSupplier, AdviseSupplierInvoice } from '../../../../types/advise';
import { engagementPriceCategories } from '../pricing';
import { useEngagementEditor } from './EngagementEditorContext';
import { InvoiceLineItemsTable } from './InvoiceLineItemsTable';
import { InvoiceTaxesToggle } from './InvoiceTaxesToggle';
import { ContractDetails } from './ContractDetails';
import { InvoiceBaselineFooter } from './InvoiceBaselineFooter';
import { mostRecentInvoice } from './InvoiceView.calc';
import { InvoiceBaselineNotice } from './InvoiceBaselineNotice';
import { CountLineItemsButton } from './CountLineItemsButton';

export interface InvoiceLinesTabProps {
  supplier: AdviseCurrentSupplier;
  invoice: AdviseSupplierInvoice;
}

/** The invoice's lines and what decides the supplier's baseline: scope, taxes and, for the record, its contract. */
export const InvoiceLinesTab = ({ supplier, invoice }: InvoiceLinesTabProps) => {
  const { engagement, canEdit, currentSuppliers } = useEngagementEditor();
  const categories = engagementPriceCategories(engagement);

  return (
    <div className="flex flex-col gap-4">
      <InvoiceBaselineNotice
        supplier={supplier}
        invoice={invoice}
      />
      {canEdit && supplier.spend_entry === 'monthly_total' && <CountLineItemsButton supplierId={supplier.id} />}
      <InvoiceLineItemsTable
        lines={invoice.line_items}
        categories={categories}
        canEdit={canEdit}
        onScopeChange={(lineId, inScope) => currentSuppliers?.setLineInScope(supplier.id, invoice.id, lineId, inScope)}
        onCategoryChange={(lineId, category) =>
          currentSuppliers?.setLineCategory(supplier.id, invoice.id, lineId, category)
        }
      />
      <InvoiceTaxesToggle
        taxes={(mostRecentInvoice(supplier) ?? invoice).taxes_and_surcharges}
        included={supplier.include_taxes}
        canEdit={canEdit}
        onChange={(included) => currentSuppliers?.setIncludeTaxes(supplier.id, included)}
      />
      <div className="border-t border-grey-2 pt-4">
        <ContractDetails
          contract={supplier.contract}
          canEdit={canEdit}
          onSave={(contract) => currentSuppliers?.saveContract(supplier.id, contract)}
        />
      </div>
      <InvoiceBaselineFooter supplier={supplier} />
    </div>
  );
};
